import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import Bidding from 'views/about/bidding/bidding.view';
import BoardOfDirectors from 'views/about/board-of-directors/board-of-directors.view';
import BoardMeetings from 'views/about/board-meetings/board-meetings.view';
import History from 'views/about/history/history.view';
import PolicyAndProcedures from 'views/about/policy-and-procedures/policy-and-procedures.view';

import MuncieLandBankHeroImage from 'assets/images/muncie-land-bank.jpg';

import BallBrothersFoundationImage from 'assets/images/ball-brothers-foundation.png';
import UrbanLightCDCImage from 'assets/images/urban-light-cdc.png';
import CityOfMuncieImage from 'assets/images/city-of-muncie.png';
import PathStoneImage from 'assets/images/pathstone.png';
import MuncieActionPlanImage from 'assets/images/MAP-new-logo.png';
import MutualBankImage from 'assets/images/nw-logo.png';
import VectrenFoundationImage from 'assets/images/vectren-foundation.png';

import Page from 'components/page/page.component';

import './style.css';
const Partner = ({ imgSrc, name, url }) => {
    return (
        <div className="partner">
            <a href={url} alt="Partner Link" target="window">
                <img src={imgSrc} alt={name} />
            </a>
        </div>
    );
};

const About = () => {
    return (
        <Page
            className="about"
            heroLinkLabel="View Properties"
            heroLinkTo="/properties"
            heroImgSrc={MuncieLandBankHeroImage}
            heroImgAlt="Muncie Land Bank"
            heroTitle="Our Mission"
            heroText="The mission of the Muncie Land Bank, Inc., is to acquire abandoned and blighted property, preserve it, and provide it to the public for strategic redevelopment."
        >
            <Container>
                <Row>
                    <Col className="d-flex justify-content-center mt-5">
                        <h3>Proudly Partnered With</h3>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} className="partners">
                        <Partner
                            imgSrc={MuncieActionPlanImage}
                            name="Muncie Action Plan"
                            url="https://www.muncieactionplan.net/"
                        />
                        <Partner imgSrc={MutualBankImage} name="Northwest Bank" url="https://www.northwest.bank/" />
                        <Partner imgSrc={PathStoneImage} name="PathStone" url="https://pathstoneindiana.org/" />
                        <Partner imgSrc={CityOfMuncieImage} name="City of Muncie" url="https://www.cityofmuncie.com/" />
                        <Partner
                            imgSrc={UrbanLightCDCImage}
                            name="Urban Light CDC"
                            url="https://www.urbanlightcdc.org/"
                        />
                        <Partner
                            imgSrc={BallBrothersFoundationImage}
                            name="Ball Brothers Foundation"
                            url="https://www.ballfdn.org/"
                        />
                        <Partner
                            imgSrc={VectrenFoundationImage}
                            name="Vectren Foundation"
                            url="https://www.centerpointenergy.com/en-us/corporate/community/centerpoint-energy-foundation"
                        />
                    </Col>
                </Row>
                <Row>
                    <Col className="d-flex justify-content-center mt-5 pt-5 mb-3">
                        <h3>Frequently Asked Questions</h3>
                    </Col>
                </Row>
                <Row className="faq">
                    <Col xs={12}>
                        <div className="faq-entries">
                            <div className="faq-entry">
                                <h4 className="faq-entry-title">What is a land bank?</h4>
                                <p className="faq-entry-answer">
                                    A land bank is a redevelopment tool that was popularized in Cuyahoga County, Ohio
                                    during the midst of the foreclosure crisis. Land banks are given ownership of tax
                                    delinquent properties, abandoned properties, or undesirable properties for whatever
                                    reason, and restores those properties to purposeful use.
                                </p>
                            </div>
                            <div className="faq-entry">
                                <h4 className="faq-entry-title">Why does Muncie need a land bank?</h4>
                                <p className="faq-entry-answer">
                                    Muncie has thousands of abandoned properties that are dangerous for the community
                                    and decrease the property values of our homes. Muncie Land Bank is able to sell
                                    properties below market value in order to increase property values and restore the
                                    community.{' '}
                                </p>
                                <p className="faq-entry-answer">
                                    Local governments have a lengthy and tedious process to go through to restore an
                                    abandoned or tax delinquent property. Muncie Land Bank would be able to curtail
                                    abandonment and increase the tax base at a more efficient rate than local
                                    governments.
                                </p>
                            </div>
                            <div className="faq-entry">
                                <h4 className="faq-entry-title">
                                    What does Muncie Land Bank do with the property it receives?
                                </h4>
                                <p className="faq-entry-answer">
                                    First, a property must be inspected to determine if any structures will be renovated
                                    or demolished. Once a decision is made on what to do with the property we initiate
                                    the appropriate process to return the property to productive use.{' '}
                                </p>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </Page>
    );
};

export { Bidding, BoardOfDirectors, BoardMeetings, History, PolicyAndProcedures };
export default About;
